<template>
  <main id="about-us" style="background-color: #274c8e">
    <div class="bg-canvas">
      <div class="bg-gradient">
        <section id="about-us-section">
          <CardJumboTron :imageSrc="AboutUsBg">
            <p class="text-white text-sub-title" style="line-height: 100%">
              Selamat Datang di <span class="text-orange">Efunding</span>
            </p>
            <h1
              class="text-white text-title"
              style="line-height: 100%; text-transform: capitalize; font-weight: 600"
            >
              Platform Agregator Syariah
              <span class="text-orange">Pertama!</span>
            </h1>
            <p class="text-white text-sub-title">
              yang mendapatkan tanda
              <span class="text-orange">Terdaftar</span> dari OJK
            </p>
            <p class="text-description mt-3" style="font-size: 18px">
              Efunding sebagai Penyelenggara Agregasi Jasa Keuangan (PAJK)
              berkomitmen menyediakan akses informasi produk dan layanan
              keuangan syariah yang lengkap, transparan, dan relevan. Melalui
              sistem elektronik berbasis internet, kami menghimpun, menyaring, dan
                membandingkan data dari berbagai Lembaga Jasa Keuangan
                Syariah untuk membantu masyarakat membuat keputusan yang
                lebih bijak.
            </p>
            <p class="text-description" style="font-size: 18px">
              Dengan inovasi teknologi, kami menghadirkan pengalaman digital
              yang unggul dalam menjelajahi dunia keuangan syariah. Bergabunglah
              dan temukan cara baru mengakses informasi yang terpercaya dan bermanfaat.
            </p>
          </CardJumboTron>
        </section>
      </div>
    </div>

    <section id="efunding-mission" class="container">
      <h2 class="section-header">
        Visi dan Misi <span class="section-header-orange">Efunding</span>
      </h2>
      <p class="section-description">
        Dengan berlandaskan inovasi, integritas, dan semangat 
        inklusivitas, kami bertekad menjadi kekuatan utama 
        dalam industri ini. Tujuan kami adalah menghadirkan 
        masa depan finansial yang lebih terang bagi masyarakat 
        dan dunia usaha, seraya terus mengutamakan kepuasan pengguna 
        dan kemajuan ekosistem keuangan syariah.
      </p>

      <!-- VISI -->
      <div class="row-section" style="margin-top: 5%">
        <div class="d-flex justify-content-center">
          <img
            :src="MissionImg"
            alt="Visi Image"
            class="img-fluid rounded shadow"
          />
        </div>
        <div class="content2">
          <h2 class="section-header" style="text-align: left">Visi</h2>
          <p class="section-description" style="text-align: left">
            Menjadi Platform Fintech Aggregator Terdepan yang Memberdayakan
            Ekonomi Digital di Indonesia dengan Prinsip Syariah.
          </p>
        </div>
      </div>

      <!-- MISI -->
      <div class="row-section reverse">
        <div class="d-flex justify-content-center">
          <img
            :src="VisionImg"
            alt="Misi Image"
            class="img-fluid rounded shadow"
          />
        </div>
        <div class="content2">
          <h2 class="section-header" style="text-align: right">Misi</h2>
          <ul class="pl-3">
            <li class="section-description" style="text-align: right">
              1. Menyediakan akses keuangan yang inklusif, adil, dan transparan
              bagi seluruh lapisan masyarakat.
            </li>
            <li class="section-description" style="text-align: right">
              2. Mendorong pertumbuhan berkelanjutan melalui inovasi teknologi
              yang berlandaskan pada nilai-nilai keISLAMan.
            </li>
            <li class="section-description" style="text-align: right">
              3. Mendukung kegiatan literasi keuangan syariah bagi seluruh
              lapisan masyarakat.
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- ! DISABLE BOARD OF Commissioners -->
    <!-- <section id="efunding-hierarchy" class="container mx-auto">
      <h2 class="section-header">
        Board of <span class="section-header-orange">Commissioners</span>
      </h2>
      <div class="d-flex flex-column flex-md-row justify-content-evenly gap-5" style="margin-top: 80px;">
        <CardAvatarImage
          v-for="(item, index) in efundingHierarchy['commissioners']"
          :key="index"
          :data="item"
          type="commissioners"
        />
      </div>

      <h2 class="section-header" style="margin-top: 80px">
        Board of <span class="section-header-orange">Management</span>
      </h2>
      <div class="d-flex flex-column flex-md-row justify-content-center" style="margin-top: 80px; gap: 40px;">
        <CardAvatarImage
          v-for="(item, index) in efundingHierarchy['management']"
          :key="index"
          :data="item"
        />
      </div>

      <h2 class="section-header" style="margin-top: 80px">
        Sharia <span class="section-header-orange">Advisor</span>
      </h2>
      <div class="d-flex justify-content-center" style="margin-top: 80px">
        <CardAvatarImage
          v-for="(item, index) in efundingHierarchy['advisor']"
          :key="index"
          :data="item"
        />
      </div>
    </section> -->

    <section id="efunding-faq" class="container">
      <h2 class="section-header">
        <span class="section-header-orange">Frequently</span> Asked Questions
      </h2>
      <p class="section-description">
        Masih memiliki pertanyaan? Silakan hubungi tim kami melalui email di
        support@efunding.id
      </p>
      <CardFaq :faq="efundingFaq" />
    </section>

    <CardGetStarted />

    <NewFooterClient />
  </main>
</template>

<script>
// Assets
import AboutUsBg from "../assets/images/landing_page/img-bg-about-us.png";
import VisionImg from "../assets/images/landing_page/img-mission.png";
import MissionImg from "../assets/images/landing_page/img-vision.png";

// Components
import CardJumboTron from "@/components/landing-page/cardJumbotron.vue";
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";
import CardFaq from "@/components/landing-page/cardFaq.vue";
import CardGetStarted from "@/components/landing-page/cardGetStarted.vue";
import CardAvatarImage from "@/components/landing-page/cardAvatarImage.vue";

// Utils
import { efundingFaq } from "@/utils/efunding_faq.js";
import { efundingHierarchy } from "@/utils/efunding_hierarchy";

export default {
  name: "Tentang",
  components: {
    CardJumboTron,
    NewFooterClient,
    CardFaq,
    CardAvatarImage,
    CardGetStarted,
  },
  data() {
    return {
      // Assets
      AboutUsBg,
      VisionImg,
      MissionImg,

      // Data
      efundingFaq,
      efundingHierarchy,
    };
  },
};
</script>

<style scoped>
.bg-canvas {
  background-image: url("../assets/images/landing_page/img-bg-canvas.png");
}
.bg-gradient {
  background: linear-gradient(
    to top,
    rgba(39, 76, 142, 1) 49%,
    rgba(39, 76, 142, 0)
  );
}
.section-header {
  color: white;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
  text-transform: capitalize;
  letter-spacing: 0;
}

.section-header-orange {
  color: #f7bd3a;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.section-description {
  color: #b3b3b3;
  text-align: center;
  font-size: 18px;
}
.container {
  max-width: 90%;
}

.visi-misi-section {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 2rem 1rem;
}

.row-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
  margin: 0 10%;
}

.row-section.reverse {
  flex-direction: row-reverse;
}

.image {
  flex: 1;
  max-width: 400px;
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.content2 {
  flex: 1;
  min-width: 280px;
  max-width: 50%;
}

.title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.mission-list {
  padding-left: 1.5rem;
}

.mission-list li {
  margin-bottom: 0.8rem;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// src/public/tentang-kami.vue